import React from 'react';
import { View, Pressable, Text, Platform } from 'react-native';
import { AntDesign } from '@expo/vector-icons';

interface HistoryControlsProps {
  onUndo?: () => void;
  onRedo?: () => void;
  onReset?: () => void;
  onSave?: () => Promise<void>;
}

/**
 * Renders the Undo, Redo, Restart, and Save buttons.
 * @param {onUndo, onRedo, onReset, onSave} - Callback functions for button presses.
 */
const HistoryControls: React.FC<HistoryControlsProps> = ({ onUndo, onRedo, onReset, onSave }) => {
  const buttons = [
    { name: 'Undo', icon: 'arrow-left', action: onUndo },
    { name: 'Redo', icon: 'arrow-right', action: onRedo },
    { name: 'Restart', icon: 'retweet', action: onReset },
    { name: 'Save', icon: 'save', action: onSave},
  ];

  return (
    <View style={{ left: -3, minWidth: 40, flex: 2.5, minHeight: 200, zIndex: 5, flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', gap: 10 }}>
      {buttons.map((btn) => (
        <Pressable key={btn.name} style={{ width: 60 }} onPress={btn.action}>
          <View style={{ flex: 1, flexWrap: 'wrap', minWidth: 60, marginVertical: 2, padding: 1, borderRadius: 15, maxHeight: 50, alignContent: 'center' }}>
            <AntDesign name={btn.icon as any} size={btn.iconSize || 24} color={Platform.select({web: 'black', default: 'white'})} style={{ alignSelf: 'center', overflow: 'visible', padding: 3 }} />
            <Text adjustsFontSizeToFit numberOfLines={2} style={{ flex: 1, flexWrap: 'wrap', fontSize: 12, color: Platform.select({web: 'black', default: 'white'}), alignSelf: 'center', textAlign: 'center' }}>{btn.name}</Text>
          </View>
        </Pressable>
      ))}
    </View>
  );
};

export default React.memo(HistoryControls);